import ReduxSelectField from './ReduxSelectField';

export default ReduxSelectField;
